export default __webpack_public_path__ + "static/3-6a091e74ad18c20ebe8bc36492038034.jpg";